import React, { useEffect } from 'react';
import environments from 'src/env';
import { readJson } from 'src/core/engine/utils/readJson';
import { APP_ENV_STATE_ID } from 'src/core/engine/browser/initBrowserApollo';
import { scheduleIdle } from 'src/components/Scripts/scheduleIdle';

const appEnv = readJson(APP_ENV_STATE_ID);

export const SmartlookBoundary = ({ children }: { children: React.ReactNode }): React.ReactNode => {
    useEffect(() => {
        return scheduleIdle(() => {
            const isMaster = appEnv.RELEASE_STAGE === 'production';
            const key = environments[isMaster ? 'master' : appEnv.RELEASE_STAGE].SMARTLOOK_ID;
            if (!key) return;
            import(/* webpackChunkName: "smartlook" */ 'smartlook-client')
                .then((Smartlook) => {
                    Smartlook.default.init('0c0c279e5220c9afc1da2cde73569c03b5e9da31');
                })
                .catch(() => {
                    /* ignore */
                });
        }, 3000);
    }, []);

    return children;
};
